module.exports = __webpack_public_path__ + "static/media/op-machine.3cc92c41.png";